import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import { CustomNumberField } from '../../../../../components/CustomNumberField';
import { CustomTextField } from '../../../../../components/CustomTextField';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import ArrowBackIcon from '../../../../../components/Icons/ArrowBackIcon';
import ArrowDownwardIcon from '../../../../../components/Icons/ArrowDownwardIcon';
import { DateMaskedInput } from '../../../../../components/MaskedInputs';
import { Row } from '../../../../../components/Row';
import { CONTRATO_EDIT_ETAPA_VALIDACAO } from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoDistratoEditRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import {
  changeContratoAssessorEditingValue,
  contratoAssessorRegisterPreEtapa,
} from '../../../../../store/modules/ContratosAssessoresActions';
import { diferenceMonths } from '../../../../../utils/DateUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  allIsTrue,
  dateIsValid,
  integerIsValid,
  maskedValueRequiredIsValid,
  requiredIsValid,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './DadosContrato.scss';
import GenericDados from './GenericDados';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-dados-contrato';

const INITIAL_STATE = {
  sending: false,

  dataInicioChanged: false,
  totalMesesChanged: false,
  dataFimChanged: false,
  reembolsoChanged: false,
};

class DadosContrato extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            id='previous-button'
            label={this.props.languageValues.anterior}
            theme='pufvYellow'
            onClick={this.toPrevContent}
            leftIcon={<ArrowBackIcon />}
          />
        </Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            id='button-next-etapa'
            label={this.props.languageValues.concluirEAvancarEtapa}
            theme='pufvYellow'
            onClick={() => {
              if (this.formIsValid()) {
                this.toSubmit(
                  this.props.bulletsIndex,
                  this.props.contratosAssessores.contratoEditing,
                  this.submitCallbackStart,
                  this.submitCallbackSuccess,
                  this.submitCallbackError
                );
              }
            }}
            rightIcon={<ArrowDownwardIcon />}
            disabled={this.submitButtonIsDisabled()}
          />
        </Col>
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    if (this.hasPermissions()) {
      return this.props.loading || this.state.sending || !this.formIsValid();
    }
    return true;
  };

  fieldDisabled() {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.assessor.edit) {
        return true;
      }
    }
    return this.state.sending || this.props.loading;
  }

  reset() {
    this.setState(INITIAL_STATE);
  }

  componentWillUnmount() {
    this.reset();
  }

  componentDidMount() {
    this.setDataFim();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setDataFim();
    }
  }

  setDataFim = () => {
    const date = new Date();
    const path = this.props.location.pathname;
    const contemId = this.verificaPathSeTemID(path);
    if (contemId) {
      this.props.changeContratoAssessorEditingValue(
        'dataFim',
        this.props.contratosAssessores.contratoEditing.dataFim,
      );
    } else {
      this.props.changeContratoAssessorEditingValue(
        'dataFim',
        `31/12/${date.getFullYear()}`
      );
    }
  }

  verificaPathSeTemID = (path) => {
    const segments = path.split('/');
    const idSegment = segments[segments.length - 2];
    return !isNaN(idSegment) && idSegment !== '';
  }

  dataInicioIsValid = () => {
    const value = this.props.contratosAssessores.contratoEditing.dataInicio;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataInicio.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataInicio.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  totalMesesIsValid = () => {
    const value = this.props.contratosAssessores.contratoEditing.totalMeses;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.totalMeses.required
    );
    const validation = integerIsValid(
      value,
      true,
      this.props.languageValues.validations.totalMeses.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  dataDistratoIsValid = () => {
    const value = this.props.contratosAssessores.contratoEditing.dataDistrato;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataDistrato.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataDistrato.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  onDataInicioChanged = (value) => {
    let months = diferenceMonths(
      value,
      this.props.contratosAssessores.contratoEditing.dataFim
    );
    this.props.changeContratoAssessorEditingValue('totalMeses', months);
  };

  formIsValid() {
    const arr = [
      this.props.contratosAssessores.contratoEditing.versaoContrato !==
        CONTRATO_VERSAO_DISTRATO
        ? this.dataInicioIsValid().status
        : true,
      this.props.contratosAssessores.contratoEditing.versaoContrato !==
        CONTRATO_VERSAO_DISTRATO
        ? this.totalMesesIsValid().status
        : true,
      this.props.contratosAssessores.contratoEditing.versaoContrato ===
        CONTRATO_VERSAO_DISTRATO
        ? this.dataDistratoIsValid().status
        : true,
    ];
    return allIsTrue(arr);
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cadastroContratoDadosContrato}
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.props.loading,
      },
    };
  };

  submitCallbackStart = () => {
    this.setState({
      sending: true,
    });
  };

  submitCallbackSuccess = () => {
    this.setState({
      sending: false,
    });
    const idContrato =
      this.props.contratosAssessores.contratoEditing.idContrato;
    const idAditivo = this.props.contratosAssessores.contratoEditing.idAditivo;
    const idDistrato =
      this.props.contratosAssessores.contratoEditing.idDistrato;
    const etapa = CONTRATO_EDIT_ETAPA_VALIDACAO;
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        this.props.history.push(
          contratoAditivoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idAditivo,
            etapa
          )
        );
        break;
      case CONTRATO_VERSAO_DISTRATO:
        this.props.history.push(
          contratoDistratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idDistrato,
            etapa
          )
        );
        break;
      default:
        this.props.history.push(
          contratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            etapa
          )
        );
        break;
    }
  };

  submitCallbackError = () => {
    this.setState({
      sending: false,
    });
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(
                this.props.bulletsIndex,
                this.props.contratosAssessores.contratoEditing,
                this.submitCallbackStart,
                this.submitCallbackSuccess,
                this.submitCallbackError
              );
            }
          }}
        >
          <button
            type='submit'
            className='hidden-button'
            disabled={this.submitButtonIsDisabled()}
          ></button>
          {this.props.contratosAssessores.contratoEditing.versaoContrato !==
            CONTRATO_VERSAO_DISTRATO ? (
            <>
              <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'data-inicio')}
                    label={this.props.languageValues.cadastroContratoDataInicio}
                    name='dataInicio'
                    value={
                      this.props.contratosAssessores.contratoEditing.dataInicio
                    }
                    onChange={(event) => {
                      const value = event.target.value.trim();
                      if (value.length === 10) {
                        this.setValue(event, () =>
                          this.onDataInicioChanged(value)
                        );
                      }
                    }}
                    InputProps={{
                      inputComponent: DateMaskedInput,
                    }}
                    helperText={
                      this.state.dataInicioChanged &&
                        !this.dataInicioIsValid().status
                        ? this.dataInicioIsValid().error
                        : ''
                    }
                    error={
                      this.state.dataInicioChanged &&
                      !this.dataInicioIsValid().status
                    }
                    disabled={this.fieldDisabled()}
                  />
                </Col>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, 'total-meses')}
                    label={this.props.languageValues.cadastroContratoTotalMeses}
                    name='totalMeses'
                    value={Number(
                      this.props.contratosAssessores.contratoEditing.totalMeses
                    ).toString()}
                    onChange={(event) => {
                      this.setValue(event);
                    }}
                    onlyInteger={true}
                    onlyPositive={true}
                    error={
                      this.state.totalMesesChanged &&
                      !this.totalMesesIsValid().status
                    }
                    helperText={
                      this.state.totalMesesChanged &&
                        !this.totalMesesIsValid().status
                        ? this.totalMesesIsValid().error
                        : ''
                    }
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'data-fim')}
                    label={this.props.languageValues.cadastroContratoDataFim}
                    name='dataFim'
                    value={
                      this.props.contratosAssessores.contratoEditing.dataFim
                    }
                    onChange={this.setValue}
                    InputProps={{
                      inputComponent: DateMaskedInput,
                      readOnly: true,
                    }}
                    disabled={true}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col cols={[12, 12, 6, 6, 6]}>
                <CustomTextField
                  id={getElementID(rootElementId, 'data-distrato')}
                  label={this.props.languageValues.cadastroContratoDataDistrato}
                  name='dataDistrato'
                  value={
                    this.props.contratosAssessores.contratoEditing.dataDistrato
                  }
                  onChange={(event) => {
                    const value = event.target.value.trim();
                    if (value.length === 10) {
                      this.setValue(event, () =>
                        this.onDataInicioChanged(value)
                      );
                    }
                  }}
                  InputProps={{
                    inputComponent: DateMaskedInput,
                  }}
                  disabled={this.fieldDisabled()}
                />
              </Col>
            </Row>
          )}
        </form>
      </GenericCardScreen>
    );
  }
}

DadosContrato.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoAssessorEditingValue,
      contratoAssessorRegisterPreEtapa,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DadosContrato));
